import { fileTypeValues } from "@ac-expo/api-types";
import { z } from "zod";

export const fileSchema = z.object(
  {
    key: z.string(),
    name: z.string(),
    type: z.enum(fileTypeValues),
    isFromTemplate: z.boolean().optional(),
  },
  {
    message: "Le fichier est requis",
  },
);

export type FileSchemaType = z.infer<typeof fileSchema>;
